import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 公司数据仓库
 */
const companyRepository = {

  /**
   * 设置公司数据仓库
   */
  setCompanyRepository (companyId, url, databaseName, userName, password) {
    return axios.post(base.companyRepository.setCompanyRepository, utils.postParamsArrayToJsonString({ companyId, url, databaseName, userName, password }))
  },
  /**
   * 查询公司数据仓库
   */
  getCompanyRepository (companiesId) {
    return axios.post(base.companyRepository.getCompanyRepository, utils.postParamsArrayToJsonString({ companiesId }))
  },
}

export default companyRepository